import React, { Component } from 'react';
import style from './index.css';
import Audio from '../Audio';
import Visualizer from './visualizer';
import Recorder from './recorder.js';
import {formatTime} from 'common/utils';
import {uploadAudio} from '../../../common/api';
import config from  '../../../config';

export default class RecorderHtml extends Component{

	constructor (props){
		super(props);
		this.state = {
			recordStatus: 'unRecord',
			recordTime: 0,
			canH5: true
		}
		this.recorder = null
		this.visualizer = null
	}

	componentWillMount () {
		this.recorder = new Recorder();
		this.recorder.getStream()
			.catch(err => {
				this.setState({canH5: false})
			})
		}

	componentDidUpdate(){
		let that = this;
		if (this.state.recordStatus === 'recording'){
			if (!this.visualizer) {
				this.visualizer = new Visualizer(that.refs.canvas, this.recorder.stream, {timeLimit: this.props.answerTime});
				this.visualizer.play();
			}
			if (!that.timer){
				that.timer = setInterval(function(){
					that.setState({recordTime: that.state.recordTime + 1});
				}, 1000)
			}
			if (this.state.recordTime === this.props.answerTime){
				this.stopRecord();
				this.setState({recordStatus: 'recorded'});
			}
		}
	}


	componentWillUnmount(){
		if (this.visualizer) { this.visualizer.destroy() }
	}

  flashUploadOK(res){
		let audioCBInfo = JSON.parse(res.message);
		let audioInfo = {
			path: audioCBInfo.data.path,
			duration: audioCBInfo.data.duration
		}
		this.uploadSuc(audioInfo);
		this.setState({audioSrc: audioInfo.path, recordTime: 0, duration: audioInfo.duration})
	}

	getRecorderType(){
		if (!this.state.canH5){
			window.flashUploadCK = this.flashUploadOK.bind(this)
		}
		return this.state.canH5 ? 'h5' : 'flash'
	}

	recorderControl(){
		let recordStatus = this.state.recordStatus;
		if (recordStatus === 'unRecord'){
			this.startRecord();
			recordStatus = 'recording';
		}else if(recordStatus === 'recording'){
			this.stopRecord();
			recordStatus = 'recorded';
		} else if (recordStatus === 'recorded'){
			this.startRecord();
			recordStatus = 'recording';
		}
		this.setState({recordStatus: recordStatus})
	}

	startRecord(){
		this.recorder.start();
		// this.visualizer.play();
	}

	stopRecord(){
		let that = this;
		clearInterval(this.timer);
		this.timer = null;
    this.visualizer.stop();
		this.visualizer = null;
		let blobData = this.recorder.end();
		let duration = this.state.recordTime;
		uploadAudio({blobData, duration}).then(function(audioInfo){
			that.uploadSuc(audioInfo);
			that.setState({audioSrc: audioInfo.path, recordTime: 0, duration: audioInfo.duration})
		});
		// let URL = window.URL || window.webkitURL;
		// let src = URL.createObjectURL(blobData);
		// that.setState({audioSrc: src})

	}

	uploadSuc(audioInfo){
		this.props.saveAnswer(audioInfo);
	}

	createRecorderHtml(){
		let {recordTime, recordStatus, audioSrc, duration} = this.state;
		const {answerTime} = this.props;
		let recordTimeStr = answerTime ? `${formatTime(recordTime)}/${formatTime(answerTime)}` : `${formatTime(recordTime)}`;
		audioSrc = audioSrc ? window.location.protocol + config.cdnCommon + audioSrc : '';
		let h5Html = '';
		if (recordStatus === 'unRecord'){
		  h5Html = (
				<div>
					<canvas ref="canvas" className={style.soundWave} width="1000" height="600"></canvas>
					<div className={style.bottomBtn}>
						<div className={style.startBtn} onClick={this.recorderControl.bind(this)}></div>
						<span>点击开始录音,可以反复录哦</span>
					</div>
				</div>
			)
		}else if (recordStatus === 'recording'){
			h5Html = (
				<div>
					<canvas ref="canvas" className={style.soundWave} width="1000" height="600"></canvas>
					<div ref="recordTime">{recordTimeStr}</div>
					<div className={style.stopBtn} onClick={this.recorderControl.bind(this)}>
						<div className={style.squareBtn}></div>
					</div>
				</div>
			)
		}else if (recordStatus === 'recorded'){
			h5Html = (
				<div className={style.reprtRecord}>
					<Audio className={style.recordAudio} src={audioSrc || ''} duration={duration}/>
					<span className={style.restartRecord} onClick={this.recorderControl.bind(this)}>重录</span>
				</div>
			)
		}

		let valueParmas = `callname=flashUploadCK&posturl=http:${config.api.ti}/upload&recordtime=${answerTime}`;
		let flashHtml = (
			<div>
				<object id="auto" name="myDynamicContent" width={ 450 } height={ 200 }
								type="application/x-shockwave-flash" data="/new_record.swf"
				>
					<param name="menu" value="false" />
					<param name="allowscriptaccess" value="always" />
					<param name="wmode" value="transparent" />
					<param name="bgcolor" value="#000000" />
					<param name="flashvars" value={ valueParmas } />
				</object>
			</div>
		);
		let recorderHtml = this.getRecorderType() === 'h5' ? h5Html : flashHtml;

		return recorderHtml;
	}

	render(){
		return (
			<div className={style.recorderHtml}>
				{this.createRecorderHtml()}
		  </div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Recorder/index.js
 **/